import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';

// project imports
import { DASHBOARD_PATH } from 'config';
import FairplayLogo from 'assets/images/fairplay-logo.png';
import ArionPlayLogo from 'assets/images/ArionPlayLogo.svg';
import XoPlayLogo from 'assets/images/xoplay-logo.svg';
import LuckyPlayLogo from 'assets/images/luckyplaylogo.png';
import PeryaPlayLogo from 'assets/images/northalley-logo.png';

const THEME = import.meta.env.VITE_APP_USE_THEME;

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link
        component={RouterLink}
        to={DASHBOARD_PATH}
        aria-label="theme-logo"
        className=""
        sx={{ alignItems: 'center', display: 'flex', position: 'relative', top: '0px' }}
    >
        {/* <Logo /> */}
        {THEME === 'xoplay' && <img src={XoPlayLogo} alt="XOplay" width="180px" />}
        {THEME === 'fairplay' && <img src={FairplayLogo} alt="Fairplay" width="85px" />}
        {THEME === 'arionplay' && <img src={ArionPlayLogo} alt="Arionplay" width="220px" />}
        {THEME === 'luckyplay' && <img src={LuckyPlayLogo} alt="Luckyplay" width="160px" />}
        {THEME === 'peryaplay' && <img src={PeryaPlayLogo} alt="Peryaplay" width="200px" />}
    </Link>
);

export default LogoSection;
